var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"home__img"},[_c('img',{attrs:{"alt":"vándornapló_fooldal","src":_vm.image}})]),_c('h1',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }